export default {
  errorMessage: "This field is required",
  errorEmail: "Please enter a valid email",
};
